import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { GenericDialogData } from '../../models/generic.dialog.interface';
import { GenericPageTypes } from '../../enums/generic-page-types.enum';
import { Subscription } from 'rxjs';
import { AreaSourceEditComponent } from '../area-source-edit/area.source.edit.component';
import { IdiAreaSource } from '../../../shared/models/Idiarea.source.interface';
import { SubareaSourceEditComponent } from '../../subarea-source/subarea-source.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-area-source-list',
  templateUrl: './area-source-list.component.html',
  styleUrls: ['./area-source-list.component.scss']
})
export class AreaSourceListComponent implements OnInit, OnDestroy {
  displayedColumns = ['subArea_Name', 'status'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  areas: IdiAreaSource[];
  pagetypeEnum = GenericPageTypes;

  private dealerSubscription: Subscription;

  constructor(private adminService: AdminService, private route: ActivatedRoute, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.dealerSubscription = AdminService.impersonatedDealer$.subscribe(dealerId => {
      this.refreshAreas();
    });

    this.refreshAreas();
  }

  ngOnDestroy(): void {
    this.dealerSubscription.unsubscribe();
  }

  showAreaSourceEdit(areaId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: areaId } as GenericDialogData;
    dialogConfig.width = '900px';

    const areaDialogRef = this.dialog.open(AreaSourceEditComponent, dialogConfig);

    areaDialogRef.afterClosed().subscribe(result => {
      this.refreshAreas();
      console.log(`Dialog result: ${result}`);
    });
  }

  showSubAreaEdit(subAreaId) {
    const dialogSubAreaConfig = new MatDialogConfig();

    dialogSubAreaConfig.data = { id: subAreaId } as GenericDialogData;
    dialogSubAreaConfig.width = '900px';

    const subAreaDialogRef = this.dialog.open(SubareaSourceEditComponent, dialogSubAreaConfig);

    subAreaDialogRef.afterClosed().subscribe(result => {
      this.refreshAreas();
      console.log(`Dialog result: ${result}`);
    });
  }

  toggleAreaStatus(page: string, id) {
    let dealerId = this.adminService.getDealerId();

    this.adminService.toggleStatus(page, id, dealerId)
      .subscribe(result => {
        console.log(result);
        if (result.id > 0) {
          this.areas.find(al => al.area_ID == id).area_IsActive = result.isActive;
        }
      });
  }

  toggleSubAreaStatus(page: string, areaId, subAreaId) {
    let dealerId = this.adminService.getDealerId();

    this.adminService.toggleStatus(page, subAreaId, dealerId)
      .subscribe(result => {
        console.log(result);
        if (result.id > 0) {
          let subArea_Area = this.areas.find(al => al.area_ID == areaId);
          subArea_Area.subAreas.find(sa => sa.subArea_ID == subAreaId).subArea_IsActive = result.isActive;
        }
      });
  }

  refreshAreas() {
    this.adminService.getIDIAreaList()
      .subscribe({
        next: (data) => {
          this.areas = data;
        }
      });
  }
}
